import { render } from "./Marketing.vue?vue&type=template&id=65330cdd&scoped=true"
import script from "./Marketing.vue?vue&type=script&lang=ts"
export * from "./Marketing.vue?vue&type=script&lang=ts"

import "./Marketing.vue?vue&type=style&index=0&id=65330cdd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65330cdd"

export default script